module.exports = __webpack_public_path__ + "img/prize.f065e81b.png";